import { Card, CardContent, CardHeader, styled } from "@mui/material"

import {
    BORDER_RADIUS,
    PADDING_BASE_MULTIPLIER,
} from "../../themes/defaultThemeParams"
/**
 * Styled card container component for use across App. Should be used over
 * generic material UI card component.
 */
const AppCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(PADDING_BASE_MULTIPLIER),
    borderRadius: theme.shape.borderRadius * BORDER_RADIUS,
    boxShadow: theme.shadows[0],
    backgroundColor: theme.palette.background.frameBackground,
    backgroundImage: "none",
}))

/**
 * Styled card header component for use across App. Should be used over
 * generic material UI card header component.
 */
const AppCardHeader = styled(CardHeader)(({ theme }) => ({
    // Padding applied in card container
    padding: theme.spacing(0),
    marginBottom: theme.spacing(2),
}))

const AppCardContent = styled(CardContent)(({ theme }) => ({
    // Padding applied in card container
    padding: theme.spacing(0),
    "&:last-child": {
        paddingBottom: theme.spacing(0),
    },
}))

export { AppCard, AppCardHeader, AppCardContent }
